import NotFoundComponent from "../components/notfounfcomponents/notfoundcomponent"

const NotFoundPage = ()=>{
    return(<NotFoundComponent/>)
}
export default NotFoundPage